var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#2F2317;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st1{fill:#FFCE00;}\n\t.st2{fill:#2F2317;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#2F2317;stroke-width:16;stroke-linecap:round;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M4.5,160.5"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 269,
  cy: 271,
  r: 261
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 386.87,
  cy: 190.21,
  r: 38.14
}), /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 401.86,
  cy: 177.94,
  r: 9.54
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 150.94,
  cy: 189.66,
  r: 38.14
}), /*#__PURE__*/React.createElement("circle", {
  className: "st3",
  cx: 165.92,
  cy: 177.4,
  r: 9.54
})), /*#__PURE__*/React.createElement("line", {
  className: "st4",
  x1: 349.04,
  y1: 260.56,
  x2: 210.07,
  y2: 260.56
}));

function SvgMood3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 540 540",
    style: {
      enableBackground: "new 0 0 540 540"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood3);
export default __webpack_public_path__ + "static/media/mood3.d265b22f1ea671b5d918f3d1d1c981b1.svg";
export { ForwardRef as ReactComponent };